import { CommonModule } from '@angular/common'
import { Component, computed, input, output } from '@angular/core'
import { WebUtilityModule } from '@engineering11/web-utilities'
import { TranslateModule } from '@ngx-translate/core'
import { ApplicationEventTokenType, IApplicationHistory, IApplicationHistoryJobTitleClickPayload } from '../../model/application-history.model'

@Component({
  selector: 'application-history',
  standalone: true,
  imports: [CommonModule, TranslateModule, WebUtilityModule],
  templateUrl: './application-history.component.html',
  styleUrls: ['./application-history.component.scss'],
})
export class ApplicationHistoryComponent {
  applicationHistory = input<IApplicationHistory[] | null>()
  jobTitleClick = output<IApplicationHistoryJobTitleClickPayload>()

  orderedApplicationHistory = computed(() =>
    this.applicationHistory()?.map(history => ({ ...history, tokens: this.getOrderedTokens(history.tokens) }))
  )

  readonly tokenType = ApplicationEventTokenType

  getOrderedTokens(tokens: IApplicationHistory['tokens']) {
    return tokens ? [...tokens].sort((a, b) => a.index - b.index) : []
  }

  onJobTitleClick(token: { id: string; applicationId?: string }, event: Event) {
    event.preventDefault()
    this.jobTitleClick.emit({ jobPostId: token.id, applicationId: token.applicationId })
  }
}
